import styled from 'styled-components';
import Modal from '@iso/components/Feedback/Modal';
import WithDirection from '@iso/lib/helpers/rtl';

const CorporateGroupModalWrapper = styled(Modal)`
  .btn-success{
    background-color: #0B2A1B;
    border-color: #0B2A1B;
    &:hover{
      opacity: 0.8;
    }
  }
  .ant-modal-body{
    padding: 0;
  }
  .form-body{
    padding: 12px 24px 12px 24px;
  }
  .pin-hint{
    color: #888;
    font-size: 12px;
    margin-top: -8px;
    margin-bottom: 12px;
  }
`;

export default WithDirection(CorporateGroupModalWrapper);
